<template>
  <div
    id="search"
    class="bg-white border rounded border-primary filter"
    :class="{ show: show }"
  >
    <div class="container">
      <div class="row justify-content-between">
        <div class="p-2">
          <h3>Filter</h3>
        </div>
        <div class="p-2">
          <i
            class="fas fa-window-close closer"
            style="font-size: 2.6em"
            @click="hideSearchBox"
          ></i>
        </div>
      </div>

      <div class="form-row bg-white" id="filterbox">
        <div class="form-group col-md-12 type">
          <label for="type">Type</label>
          <select
              size="1"
              id="search_type"
              class="form-control"
              v-model="searchParams.type"
              @change="typeChanges"
          >
            <option :value="{ label: '', value: '' }"></option>
            <option
                v-for="type in types"
                :key="type.name"
                :value="{ label: type.label, value: type.name }"
            >
              {{ type.label }}
            </option>
          </select>
        </div>

        <div
            v-show="searchParams.type.value"
            class="form-group col-md-12 soort"
        >
          <label for="soort">Categorie</label>
          <select
              size="1"
              id="search_soort"
              class="form-control"
              v-model="searchParams.soort"
              @change="soortChanges"
          >
            <option :value="{ label: '', value: '' }"></option>
            <option
                v-for="soort in soorts"
                :key="soort.id"
                :value="{ label: soort.name, value: soort.id }"
            >
              {{ soort.name }}
            </option>
          </select>
        </div>

        <div class="form-group col-md-12 gemeente">
          <label for="gemeente">Gemeentenaam</label>
          <select
            size="1"
            id="search_gemeente"
            class="form-control"
            v-model="searchParams.gem_code"
            @change="gemeenteChanges"
          >
            <option :value="{ label: '', value: '' }"></option>
            <option
              v-for="gemeente in gemeenten"
              :key="gemeente.code"
              :value="{ label: gemeente.name, value: gemeente.code }"
            >
              {{ gemeente.name }}
            </option>
          </select>
        </div>
        <div
          v-show="searchParams.gem_code.value && searchParams.type.value !== 'LS' "
          class="form-group col-md-12 wijk"
        >
          <label for="wijk">Wijk naam</label>
          <select
            size="1"
            id="search_wijk"
            class="form-control"
            v-model="searchParams.wijk_code"
            @change="wijkChanges"
          >
            <option :value="{ label: '', value: '' }"></option>
            <option
              v-for="wijk in wijken"
              :value="{ label: wijk.name, value: wijk.code }"
              :key="wijk.code"
            >
              {{ wijk.name }}
            </option>
          </select>
        </div>
        <div
          v-show="searchParams.wijk_code.value && searchParams.type.value !== 'LS'"
          class="form-group col-md-12 buurt"
        >
          <label for="buurt">Buurt naam</label>
          <select
            size="1"
            id="search_buurt"
            class="form-control"
            v-model="searchParams.buurt_code"
            @change="buurtChanges"
          >
            <option :value="{ label: '', value: '' }"></option>
            <option
              v-for="buurt in buurten"
              :key="buurt.code"
              :value="{ label: buurt.name, value: buurt.code }"
            >
              {{ buurt.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { HIDE_SEARCH, SET_SEARCHPARAMS } from "../store/mutation-types";

export default {
  data() {
    return {
      searchParams: {
        gem_code: { label: "", value: "" },
        wijk_code: { label: "", value: "" },
        buurt_code: { label: "", value: "" },
        type: { label: "", value: "" },
        soort: { label: "", value: "" },
      },
      gemeenten: [],
      wijken: [],
      buurten: [],
      soorts: [],
    };
  },
  mounted() {
    this.fetchGemeenten();
  },
  methods: {
    async fetchGemeenten() {
      const response = await axios("/administrativeunit/gemeenten");
      this.gemeenten = response.data;
    },
    async fetchWijken() {
      const response = await axios(
        `/administrativeunit/${this.searchParams.gem_code.value}/wijken`
      );
      this.wijken = response.data;
    },
    async fetchBuurten() {
      const response = await axios(
        `/administrativeunit/${this.searchParams.wijk_code.value}/buurten`
      );
      this.buurten = response.data;
    },
    ...mapMutations({
      hideSearchBox: HIDE_SEARCH,
      setSearchParams: SET_SEARCHPARAMS,
    }),

    gemeenteChanges() {
      this.debug();
      this.searchParams.wijk_code = { label: "", value: "" };
      this.searchParams.buurt_code = { label: "", value: "" };
      this.wijken = [];
      this.buurten = [];
      if (this.searchParams.gem_code.value !== "") {
        this.fetchWijken();
      }
    },
    wijkChanges() {
      this.debug();
      this.searchParams.buurt_code = { label: "", value: "" };
      this.buurten = [];
      if (this.searchParams.wijk_code.value !== "") {
        this.fetchBuurten();
      }
    },
    buurtChanges() {
      this.debug();
    },
    typeChanges() {
      this.debug();
      this.searchParams.soort = { label: "", value: "" };

      if (this.searchParams.type.value === "") {
        this.soorts = [];
      } else {
        switch (this.searchParams.type.value) {
          case "GM":
            this.soorts = this.soortGM;
            break;
          case "RM":
            this.soorts = this.soortRM;
            break;
          case "KP":
            this.soorts = this.soortKP;
            break;
          case "BG":
            this.soorts = this.soortBG;
            break;
          case "LS":
            this.soorts = this.soortLS;
            break;
          case "RG":
            this.soorts = this.soortRG;
            break;
        }
      }
    },
    soortChanges() {
      this.debug();
    },

    debug() {
      // console.log("search params changed: " + JSON.stringify(this.searchParams));
      this.setSearchParams(this.searchParams);
    },
  },
  computed: {
    show() {
      return this.$store.state.searchshow;
    },

    types() {
      return this.$store.state.config.layerconfig.filter((lc) => lc.visible);
    },

    soortRM() {
      return this.$store.state.config.soortRM;
    },
    soortGM() {
      return this.$store.state.config.soortGM;
    },
    soortKP() {
      return this.$store.state.config.soortKP;
    },
    soortBG() {
      return this.$store.state.config.soortBG;
    },
    soortLS() {
      return this.$store.state.config.soortLS;
    },
    soortRG() {
      return this.$store.state.config.soortRG;
    },
  },
};
</script>
<style lang="scss" scoped>
.filter {
  position: absolute;
  z-index: 2000;
}
</style>